module.exports = __webpack_public_path__ + "static/media/icon_partner_phone.7516d534.svg";